var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowRightNew = function SvgArrowRightNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.863 37.582v0c-9.942 0-18-8.058-18-18v0c0-9.942 8.058-18 18-18v0c9.942 0 18 8.058 18 18v0c0 9.942-8.058 18-18 18z",
    stroke: "#170426",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.57 12.875a1 1 0 00-1.414 1.414l4.293 4.293H11.863a1 1 0 100 2H25.45l-4.293 4.293a1 1 0 101.414 1.414l6-6a.995.995 0 00.217-1.09.998.998 0 00-.21-.318l-.007-.007m-6-6l6 6-6-6z",
    fill: "#170426"
  })));
};
export default SvgArrowRightNew;